export default __webpack_public_path__ + "static/media/develop_overhead.75c12a81.png";